import { render } from "./TransactionTagging.vue?vue&type=template&id=1d1029be&scoped=true"
import script from "./TransactionTagging.vue?vue&type=script&lang=js"
export * from "./TransactionTagging.vue?vue&type=script&lang=js"

import "./TransactionTagging.vue?vue&type=style&index=0&id=1d1029be&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d1029be"]])

export default __exports__